/**
  * WBT-Player Konfiguration
  * @namespace v3sWbtPlayerApp:config
  */

/**
  * Definiert den Pfad, unter welchem WBT-Inhalt erwartet wird
  * @constant v3sContentPath
  * @memberOf v3sWbtPlayerApp:config
  * @default ./content
  */
angular.module('v3sWbtPlayerApp').value('v3sContentPath', './content/');
angular.module('v3sWbtPlayerApp').value('v3sContentMediaPath', './content/');

angular.module('v3sWbtPlayerApp').config(["localStorageServiceProvider", function (localStorageServiceProvider) {
    /**
    * Definiert den Prefix in Local Storage oder Cookie
    * @constant localStorageServiceProvider.Prefix
    * @memberOf v3sWbtPlayerApp:config
    * @default v3sWbt
    */
    localStorageServiceProvider.setPrefix('v3sWbt');

    /**
    * Definiert den Standard für Speicherung der Daten ohne LMS
    * @constant localStorageServiceProvider.StorageType
    * @memberOf v3sWbtPlayerApp:config
    * @default localStorage (Fallback Cookie)
    */
    localStorageServiceProvider.setStorageType('localStorage');

    /**
    * Definiert Anzahl der Tage vor dem Ablauf der Cookie
    * @constant localStorageServiceProvider.Expiry
    * @memberOf v3sWbtPlayerApp:config
    * @default 60 Tage
    */
    localStorageServiceProvider.setStorageCookie(60, '');

    //Lese-/Schreib-Meldungen ausschalten
    localStorageServiceProvider.setNotify(false, false);
}]);


/**
* Zeigt Fehler beim Initialisieren von Local Storage bzw. Cookie an
* @function onLocalStorageError
* @memberOf v3sWbtPlayerApp:config
* @listens LocalStorageModule.notification.error
*/

angular.module('v3sWbtPlayerApp').run(["$rootScope", "$timeout", "v3sLog", "v3sI18nService", function ($rootScope, $timeout, v3sLog, v3sI18nService) {
    $rootScope.$on('LocalStorageModule.notification.error', function (event, data) {
        $timeout(function () {
            if (data === "COOKIES_NOT_SUPPORTED") {
                if (!$rootScope.cookiesWarned) {
                    $rootScope.cookiesWarned = true;
                    v3sLog.error(v3sI18nService.getText("general.cookieWarning"));
                    v3sLog.log(data);
                }
            } else {
                v3sLog.warn(v3sI18nService.getText("general.storageWarning"));
            }
        }, 3000); //abwarten bis Language geladen ist --> TODO: then() verwenden
    });
}]);

angular.module('v3sWbtPlayerApp').config(['$tooltipProvider', function ($tooltipProvider) {

    var isTouch = ('createTouch' in window.document) && /(ip(a|o)d|iphone|android)/ig.test(window.navigator.userAgent);
    var trigger = isTouch ? 'focus' : 'hover'; // bug angular-strap on ipad

    angular.extend($tooltipProvider.defaults, {
        /**
        * Definiert Animation, Trigger, Verzögerung und Container für AngularStrap-Tooltip
        * @constant  $tooltipProvider.defaults
        * @memberOf v3sWbtPlayerApp:config
        */
        animation: 'am-flip-x',
        trigger: trigger,
        delay: { show: 300, hide: 0 },
        container: 'body'
    });
}]);

angular.module('v3sWbtPlayerApp').config(['$selectProvider', function ($selectProvider) {
    angular.extend($selectProvider.defaults, {
        viewport: '#page-view'
    });
}]);

angular.module('v3sWbtPlayerApp').config(['$compileProvider', function ($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|javascript):/);
}]);